import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import RouteScrollToTop from "./elements/RouteScrollToTop";
import ScrollToTop from "react-scroll-to-top";
import HomeThree from "./pages/HomeThree";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Graduate from "./pages/Graduate-training";
import Internsip from "./pages/Internship";
import CookiesPolicy from "./pages/CookiesPolicy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfUse";
import HowItWorks from "./pages/HowItWorks";
import Error from "./pages/Error";

// 👇 cookie banner on all routes
import CookieBanner from "./elements/CookieBanner";

const App = () => {
  // 🔒 Global “no copy / no right-click / no drag” behaviour
  useEffect(() => {
    const isEditableTarget = (target) => {
      if (!target) return false;
      const tag = target.tagName;
      const editable =
        tag === "INPUT" ||
        tag === "TEXTAREA" ||
        target.isContentEditable ||
        target.closest(".allow-select");
      return !!editable;
    };

    const handleContextMenu = (e) => {
      if (!isEditableTarget(e.target)) {
        e.preventDefault();
      }
    };

    const handleCopy = (e) => {
      if (!isEditableTarget(e.target)) {
        e.preventDefault();
      }
    };

    const handleCut = (e) => {
      if (!isEditableTarget(e.target)) {
        e.preventDefault();
      }
    };

    const handleDragStart = (e) => {
      if (!isEditableTarget(e.target)) {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("copy", handleCopy);
    document.addEventListener("cut", handleCut);
    document.addEventListener("dragstart", handleDragStart);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("copy", handleCopy);
      document.removeEventListener("cut", handleCut);
      document.removeEventListener("dragstart", handleDragStart);
    };
  }, []);

  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <ScrollToTop smooth color="#196164" />

      {/* shown on every page */}
      <CookieBanner />

      <Routes>
        <Route exact path="/" element={<HomeThree />} />
        <Route exact path="/about" element={<About />} />
        <Route exact path="/contact" element={<Contact />} />
        <Route exact path="/how-it-works" element={<HowItWorks />} />
        <Route exact path="/graduate-training" element={<Graduate />} />
        <Route exact path="/internship" element={<Internsip />} />
        <Route exact path="/cookies-policy" element={<CookiesPolicy />} />
        <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route exact path="/terms-of-use" element={<TermsOfService />} />
        <Route exact path="*" element={<Error />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;